import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { IAskItems } from '../../types';
import { SRCardListItem } from 'components/Design';

const AskItems = observer(({ ask, handleCardOpen }: { ask: IAskItems; handleCardOpen: Function }) => {
	const openCardView = React.useRef() as React.MutableRefObject<HTMLInputElement>;
	const scrollToBottom = () => openCardView.current.scrollIntoView({ behavior: 'smooth', block: 'center' });

	React.useEffect(() => {
		if (openCardView.current) {
			scrollToBottom();
		}
	}, [openCardView.current, ask.showOpenCard]);

	return (
		<SRCardListItem
			id={ask.RequestType == 'JobApproval' ? ask.Details : ask.Id}
			title={
				ask.RequestType === 'Esme'
					? ask.classstructure[0].commodities[0].description
					: ask.RequestType === 'JobApproval'
					? `Approval request: ${ask.Subject}`
					: 'Feedback'
			}
			time={ask.RequestType === 'Esme' ? ask.reportDate : ask.CreatedDate}
			status={ask.RequestType === 'Esme' ? ask.statusDescription ? ask.statusDescription : <br /> : ''}
			reference={
				ask.RequestType === 'Suggestion'
					? 'Aria App Feedback'
					: ask.RequestType === 'JobApproval'
					? `${ask.Details}`
					: `${ask.Id}`
			}
			handleClick={() => handleCardOpen(ask)}
			isActive={ask.showOpenCard}
			description={ask.RequestType === 'Esme' ? ask.description : ''}
			location={ask.RequestType === 'Esme' ? ask.locationDescription : ask.Building}
		></SRCardListItem>
	);
});

export default AskItems;
